import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.UnconstrainedForecast';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Unconstrained Forecast',
    },
    header: {
        id: `${scope}.header`,
        defaultMessage: 'Unconstrained forecast from overnight run. Click row for more detail ',
    },
    nameColumnTitle: {
        id: `${scope}.nameColumnTitle`,
        defaultMessage: 'Property',
    },
    stayDateColumnTitle: {
        id: `${scope}.stayDateColumnTitle`,
        defaultMessage: 'Stay Date',
    },
    percentageColumnTitle: {
        id: `${scope}.percentageColumnTitle`,
        defaultMessage: 'Unconstrained % above room count',
    },
    daysColumnTitle: {
        id: `${scope}.daysColumnTitle`,
        defaultMessage: 'Days unconstrained',
    },
    graphRooms: {
        id: `${scope}.graphRooms`,
        defaultMessage: 'Forecast Rooms',
    },
    graphExtraRooms: {
        id: `${scope}.graphExtraRooms`,
        defaultMessage: 'Extra unconstrained demand rooms',
    },
});
